// F-05l: mobile follow-along add-to-bag bar. The native product form and its server responses stay the source of truth.
if (!customElements.get('elmsett-sticky-buy')) {
  customElements.define(
    'elmsett-sticky-buy',
    class ElmsettStickyBuy extends HTMLElement {
      connectedCallback() {
        if (this.closest('quick-add-modal')) return;
        this.form = document.getElementById(this.dataset.form);
        this.productForm = this.form?.closest('product-form');
        this.main = this.productForm?.querySelector('[type="submit"]');
        this.target = this.productForm?.querySelector('.product-form__buttons') || this.main;
        this.button = this.querySelector('.es-sticky-buy__button');
        this.label = this.querySelector('.es-sticky-buy__label');
        this.price = this.querySelector('.es-sticky-buy__price');
        if (!this.form || !this.main || !this.button || !('IntersectionObserver' in window)) return;

        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.past = false;
        this.fromBar = false;
        if (document.querySelector('cart-drawer')) this.button.setAttribute('aria-haspopup', 'dialog');

        // Shown only after the purchase buttons have scrolled above the viewport.
        this.observer = new IntersectionObserver(([entry]) => {
          this.past = !entry.isIntersecting && entry.boundingClientRect.bottom <= (entry.rootBounds?.top ?? 0);
          this.update();
        });
        this.mirror = new MutationObserver(() => this.sync());
        this.mirror.observe(this.main, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'], childList: true, characterData: true, subtree: true });
        this.errorWrapper = this.productForm.querySelector('.product-form__error-message-wrapper');
        if (this.errorWrapper) {
          this.errorObserver = new MutationObserver(() => this.revealError());
          this.errorObserver.observe(this.errorWrapper, { attributes: true, attributeFilter: ['hidden'] });
        }
        this.form.addEventListener('submit', (event) => { this.fromBar = event.submitter === this.button; }, { capture: true, signal });
        this.mobile.addEventListener('change', () => this.toggle(), { signal });
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data } = {}) => {
            if (data?.sectionId !== this.dataset.section) return;
            const next = data.html?.getElementById(this.price.id);
            if (next) this.price.innerHTML = next.innerHTML;
          });
        }
        this.sync();
        this.toggle();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.mirror?.disconnect();
        this.errorObserver?.disconnect();
        this.unsubscribe?.();
        document.documentElement.classList.remove('es-sticky-buy-ready');
      }

      toggle() {
        const on = this.mobile.matches;
        this.hidden = !on;
        document.documentElement.classList.toggle('es-sticky-buy-ready', on);
        this.observer.disconnect();
        this.past = false;
        if (on) this.observer.observe(this.target);
        this.update();
      }

      update() {
        const show = this.mobile.matches && this.past;
        if (!show && this.contains(document.activeElement) && !this.main.disabled) this.main.focus({ preventScroll: true });
        this.dataset.visible = String(show);
      }

      // Mirror the native button: disabled, sold out and loading states come from product-form.js.
      sync() {
        const loading = this.main.classList.contains('loading');
        const busy = loading || this.main.getAttribute('aria-disabled') === 'true';
        const text = this.main.textContent.trim();
        const { addLabel, soldOutLabel, unavailableLabel } = this.dataset;
        const label = this.main.disabled && [soldOutLabel, unavailableLabel].includes(text) ? text : addLabel;
        this.button.disabled = this.main.disabled;
        this.button.classList.toggle('loading', loading);
        this.button.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);
        if (busy) this.button.setAttribute('aria-disabled', 'true');
        else this.button.removeAttribute('aria-disabled');
        if (this.label.textContent !== label) this.label.textContent = label;
        this.toggleAttribute('data-sold-out', label !== addLabel);
      }

      // Errors keep their native message and recovery links; bring them into view for a bar submission.
      revealError() {
        if (this.errorWrapper.hidden || !this.fromBar) return;
        this.fromBar = false;
        const focused = this.contains(document.activeElement);
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.errorWrapper.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
        if (focused) {
          this.errorWrapper.tabIndex = -1;
          this.errorWrapper.focus({ preventScroll: true });
        }
      }
    }
  );
}
